import type { QuestionResponseType, SurveyExpiration, SurveyResponseType, SurveyStatus } from '@/shared/types/nps';

export const SURVEY_STATUS_LABEL: Record<SurveyStatus, string> = {
  DRAFT: 'Rascunho',
  ACTIVE: 'Ativa',
  FINISHED: 'Finalizada',
  PAUSED: 'Pausada',
};

export const SURVEY_STATUS_VARIANT: Record<SurveyStatus, 'success' | 'secondary' | 'warning' | 'destructive'> = {
  DRAFT: 'secondary',
  ACTIVE: 'success',
  FINISHED: 'secondary',
  PAUSED: 'warning',
};

export const SURVEY_RESPONSE_TYPE_LABEL: Record<SurveyResponseType, string> = {
  ANONYMOUS: 'Anônima',
  IDENTIFIED: 'Identificada',
};

export const EXPIRATION_LABEL: Record<SurveyExpiration, string> = {
  NEVER: 'Nunca expira',
  ONE_DAY: '1 dia',
  ONE_WEEK: '1 semana',
  ONE_MONTH: '1 mês',
  TWO_MONTHS: '2 meses',
  THREE_MONTHS: '3 meses',
  FOUR_MONTHS: '4 meses',
  FIVE_MONTHS: '5 meses',
  SIX_MONTHS: '6 meses',
  SEVEN_MONTHS: '7 meses',
  EIGHT_MONTHS: '8 meses',
  NINE_MONTHS: '9 meses',
  TEN_MONTHS: '10 meses',
  ELEVEN_MONTHS: '11 meses',
  ONE_YEAR: '1 ano',
};

export const EXPIRATION_OPTIONS = Object.entries(EXPIRATION_LABEL) as [SurveyExpiration, string][];

export const RESPONSE_TYPE_LABEL: Record<QuestionResponseType, string> = {
  STAR: 'Estrelas',
  RANGE: 'Escala (0–10)',
  BOOLEAN: 'Sim / Não',
  TEXT: 'Texto',
  SELECT: 'Seleção única',
  DATE: 'Data',
  CHECKBOX: 'Múltipla escolha',
};

export const QUESTION_TYPES: QuestionResponseType[] = ['RANGE', 'STAR', 'BOOLEAN', 'TEXT', 'SELECT', 'CHECKBOX', 'DATE'];

export function isSurveyEditable(status: SurveyStatus, options?: { isAdmin?: boolean }): boolean {
  if (status === 'FINISHED') return false;
  if (options?.isAdmin) return status === 'DRAFT' || status === 'ACTIVE' || status === 'PAUSED';
  return status === 'DRAFT';
}

/** Estrutura (criar/remover perguntas): só rascunho, mesmo para admin. */
export function isSurveyStructureEditable(status: SurveyStatus): boolean {
  return status === 'DRAFT';
}

export function normalizeIdentifiedSurveyFields<T extends { response_type: SurveyResponseType; identification_required?: boolean; answer_bonus?: boolean }>(
  data: T,
): T {
  if (data.response_type === 'ANONYMOUS') {
    return { ...data, identification_required: false, answer_bonus: false };
  }
  return data;
}
